<template>
  <svg viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M11.1722 14.5236L8.7998 16.8958L11.1722 19.2675"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round" />
    <path
      d="M11.8291 8.47095L14.2015 6.09855L11.8291 3.72705"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round" />
    <path
      d="M14.2004 6.1001H8.80039C5.81779 6.1001 3.40039 8.5184 3.40039 11.5001C3.40039 13.2209 4.20769 14.75 5.46139 15.7391"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round" />
    <path
      d="M8.7998 16.8993H14.1998C17.1824 16.8993 19.5998 14.4819 19.5998 11.4993C19.5998 9.77849 18.7925 8.24935 17.5388 7.26025"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round" />
  </svg>
</template>
